import { useContext } from "react";
import { UserContext } from "../context/UserContext";

export function UseUser() {
  const context = useContext(UserContext);

  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }

  return context;
}
